const PENDING_WEB_AUTH_TOKEN_KEY = 'run:pendingWebAuthToken';

export function storePendingWebAuthToken(token: string) {
  try {
    window.sessionStorage.setItem(PENDING_WEB_AUTH_TOKEN_KEY, token);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('[run-google-auth] pending_web_token_store_failed', {
      message: err instanceof Error ? err.message : String(err),
    });
  }
}

export function consumePendingWebAuthToken() {
  try {
    const token = window.sessionStorage.getItem(PENDING_WEB_AUTH_TOKEN_KEY);
    if (token) {
      window.sessionStorage.removeItem(PENDING_WEB_AUTH_TOKEN_KEY);
    }

    return token || undefined;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('[run-google-auth] pending_web_token_consume_failed', {
      message: err instanceof Error ? err.message : String(err),
    });
    return undefined;
  }
}

export function peekPendingWebAuthToken() {
  try {
    const token = window.sessionStorage.getItem(PENDING_WEB_AUTH_TOKEN_KEY);
    return token || undefined;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('[run-google-auth] pending_web_token_peek_failed', {
      message: err instanceof Error ? err.message : String(err),
    });
    return undefined;
  }
}

export function clearPendingWebAuthToken() {
  try {
    window.sessionStorage.removeItem(PENDING_WEB_AUTH_TOKEN_KEY);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('[run-google-auth] pending_web_token_clear_failed', {
      message: err instanceof Error ? err.message : String(err),
    });
  }
}
